module.exports = __webpack_public_path__ + "img/chat-empty.95774a7f.svg";